import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MySubject } from './my-subject';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MOrganization } from '../models/organization.model';
import { MUser } from '../models/user.model';

@Injectable()
export class GlobalsService {

    public apiUrl = environment.apiUrl;
    public imgUrl = environment.imgUrl;
    public user: MUser = (sessionStorage.activeUser !== undefined) ? JSON.parse(sessionStorage.activeUser) : undefined;
    public organizacion: MOrganization = (sessionStorage.organization !== undefined) ? JSON.parse(sessionStorage.organization) : undefined;

    dataFirstSub = new MySubject();

    data: any = {};

    constructor(
        public http: HttpClient,
        private translate: TranslateService) {

    }

    setDataFirst(data) {
        this.dataFirstSub.next(data);
    }

    public setUser(user){
        this.user = user
    }

    public setOrg(org){
        this.organizacion = org
    }

    get dataFirst(): Observable<any> {
        return this.dataFirstSub.asObservable();
    }

    getTranslate(search) {
        return this.translate.get(search);
    }
}
